module.exports = __webpack_public_path__ + "static/img/point.cdaae5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s34/pop/point.png
// module id = Tmzz
// module chunks = 2